import React from "react";
import { Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { useTranslation } from "react-i18next";
import { startOfWeek, endOfWeek, eachDayOfInterval, format } from "date-fns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ResponsiveCharts from "../ChartsLayout/ResponsiveCharts.jsx";
import CustomGridItem from "../ChartsLayout/CustomGridItem.jsx";
import {
  HiddenTypography,
  BarChartEmpty,
} from "../ChartsLayout/EmptyCharts.jsx";

export default function SleepOverview({
  sleepData,
  sleepOverview,
  selectedWeek,
}) {
  // console.log("Sleep data are:", sleepData);

  const datewWithDuration = sleepData.filter(
    (item) => item.duration !== 0 || item.duration !== null
  );
  // console.log("datewWithDuration", datewWithDuration);

  const weekStarts = startOfWeek(selectedWeek, { weekStartsOn: 1 });
  const weekEnds = endOfWeek(selectedWeek, { weekStartsOn: 1 });

  const { t } = useTranslation("statistics");

  const weekDays = eachDayOfInterval({
    start: weekStarts,
    end: weekEnds,
  });

  const formattedSleepData = sleepData.map(({ date, duration, ...rest }) => ({
    duration,
    date,
  }));
  // console.log("Sleep data in sleepOxverview: ", formattedSleepData);

  const getSleepDurationForADate = (date) => {
    const dateFormatted = format(date, "yyyy-MM-dd");
    const daySleepData = formattedSleepData.find(
      (data) => data.date === dateFormatted
    );

    return daySleepData ? daySleepData.duration : 0;
  };

  // const weeksMonthsWithData = calculateWeeksAndMonthsWithData(formattedSleepData);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ResponsiveCharts>
        {({ chartWidth }) => (
          <CustomGridItem>
            <div ref={sleepOverview}>
              <Typography
                sx={{
                  margin: {
                    xs: "20px 0",
                    sm: "20px 0",
                    md: "0 0 20px 0",
                    lg: "20px 0 0 20px",
                    xl: "20px",
                  },
                  textAlign: "center",
                }}
                variant="h6"
              >
                {t("charts.sleep.overviewTitle")}
              </Typography>
              {weekDays.some((day) => getSleepDurationForADate(day)) ? (
                <>
                  <HiddenTypography />
                  <BarChart
                    xAxis={[
                      {
                        scaleType: "band",
                        data: weekDays.map((day) => format(day, "EEE")),
                      },
                    ]}
                    series={[
                      {
                        data: weekDays.map((day) =>
                          Math.round(getSleepDurationForADate(day) / 60)
                        ),
                        label: t("series.sleepDurationHours"),
                      },
                    ]}
                    width={chartWidth}
                    height={300}
                  />
                </>
              ) : (
                <BarChartEmpty weekDays={weekDays} chartWidth={chartWidth} />
              )}
            </div>
          </CustomGridItem>
        )}
      </ResponsiveCharts>
    </LocalizationProvider>
  );
}
